// flash-fix 2026-07-24 — shared loading skeleton, self-contained (inline
// styles + one injected keyframes tag) so it renders correctly no matter
// which screen's CSS bundle has loaded. Render while a screen's FIRST fetch
// is in flight; empty-state copy may only render after the fetch settles.
import { useEffect } from 'react';

const KF_ID = 'ac-skel-kf';
function ensureKeyframes(): void {
  if (document.getElementById(KF_ID)) return;
  const el = document.createElement('style');
  el.id = KF_ID;
  el.textContent = '@keyframes acSkelShimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}';
  document.head.appendChild(el);
}

const barBase = {
  height: 16,
  borderRadius: 8,
  background: 'linear-gradient(90deg, rgba(0,0,0,.06) 25%, rgba(0,0,0,.12) 50%, rgba(0,0,0,.06) 75%)',
  backgroundSize: '200% 100%',
  animation: 'acSkelShimmer 1.2s ease-in-out infinite',
} as const;

export function Skeleton({ rows = 4, pad = 18 }: { rows?: number; pad?: number | string }): JSX.Element {
  useEffect(() => { ensureKeyframes(); }, []);
  const widths = ['40%', '80%', '60%', '80%', '55%', '70%'];
  return (
    <div aria-busy="true" style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: pad }}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} style={{ ...barBase, width: widths[i % widths.length] }} />
      ))}
    </div>
  );
}
